
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsionStatic as ObiPropulsionStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion-static.js';
 
 
 

 
 export const ObiPropulsionStatic = createComponent({
   react: React,
   tagName: 'obi-propulsion-static',
   elementClass: ObiPropulsionStaticElement,
   events: {
     
   }
  });
 
 